(function ($) {
  DJ.addBehavior('resourcesInlineFilter', '.resources-inline', {
    attach: function (context, settings, behavior) {
      const tilesWrapper = this;
      const filtersCheckboxes = Array.prototype.slice.call(
        tilesWrapper.querySelectorAll('.resources-filters__checkbox-input')
      );
      const resourcesItems = tilesWrapper.querySelectorAll('.resources-item');
      const stayClass = 'resources-item--stay';
      let currentBreakpoint = DJ.bp.name;
      let checkedValues = [];

      if (!resourcesItems) {
        return false;
      }

      const inlineItems = () => {
        const inlineWrapper = tilesWrapper.querySelector('.resources-inline__wrapper');
        const btnMore = tilesWrapper.querySelector('.js-more-inline');
        const btnLess = tilesWrapper.querySelector('.js-less-inline');
        const inlineItemAll = inlineWrapper.querySelectorAll('.resources-inline__item');
        const inlineStayAll = inlineWrapper.querySelectorAll('.resources-item--stay');

        inlineWrapper.closest('.resources-inline').classList.remove('less-items');
        inlineWrapper.closest('.resources-inline').classList.remove('more-items');

        if (tilesWrapper.classList.contains('resources--filtered')) {
          if (inlineStayAll.length > 3) {
            inlineWrapper.closest('.resources-inline').classList.add('less-items');
            inlineStayAll.item(0).classList.add('show');
            inlineStayAll.item(1).classList.add('show');
            inlineStayAll.item(2).classList.add('show');
          }
        } else if (tilesWrapper.classList.contains('resources--filtered') !== null) {
          if (inlineItemAll.length > 3) {
            inlineWrapper.closest('.resources-inline').classList.add('less-items');
          }
        }

        btnMore.addEventListener('click', (e) => {
          inlineWrapper.closest('.resources-inline').classList.remove('less-items');
          inlineWrapper.closest('.resources-inline').classList.add('more-items');
          e.preventDefault();
        });

        btnLess.addEventListener('click', (e) => {
          inlineWrapper.closest('.resources-inline').classList.remove('more-items');
          inlineWrapper.closest('.resources-inline').classList.add('less-items');
          const scrollDiv = document.getElementById('resources-inline').offsetTop;
          window.scrollTo({ top: scrollDiv + 50 });
          e.preventDefault();
        });
      };

      inlineItems();

      /**
       * Hide/show resources depending on checkboxes.
       */
      if (filtersCheckboxes.length) {
        filtersCheckboxes.forEach((filterCheckbox) => {
          filterCheckbox.addEventListener('change', (e) => {
            const resourcesFilteredClass = 'resources--filtered';

            // Save checkboxes values in the array.
            if (e.target.checked) {
              checkedValues.push(e.target.value);
            } else {
              checkedValues = checkedValues.filter((arrItem) => arrItem !== e.target.value);
            }

            // If no checkboxes checked, show all items.
            if (!checkedValues.length) {
              tilesWrapper.classList.remove(resourcesFilteredClass);
              inlineItems();
              return false;
            }

            // Hide all items when checkbox checked.
            tilesWrapper.classList.add(resourcesFilteredClass);

            const items = tilesWrapper.querySelectorAll('.resources-item');

            Array.prototype.slice.call(items).forEach((item) => {
              const tile = $(item).closest('.resources-inline__item')[0];

              if (tile && tile.classList.contains(stayClass)) {
                tile.classList.remove(stayClass);
                tile.classList.remove('show');
              }
            });

            // Show items depending on checked checkboxes.
            checkedValues.forEach((checkedValue) => {
              const itemsToStay = tilesWrapper.querySelectorAll(`.resources-item--${checkedValue}`);

              Array.prototype.slice.call(itemsToStay).forEach((itemToStay) => {
                const tile = $(itemToStay).closest('.resources-inline__item')[0];

                if (tile && !tile.classList.contains(stayClass)) {
                  tile.classList.add(stayClass);
                }
              });
            });
            inlineItems();
            return true;
          });
        });
      }

      /**
       * Recalculate items height on breakpoint change.
       */
      DJ.on('changeBreakpoint', function () {
        setTimeout(function () {
          if (currentBreakpoint !== DJ.bp.name) {
            currentBreakpoint = DJ.bp.name;
          }
        }, 500);
      });

      return true;
    }

  });
})(jQuery);
